import { REACT_APP__URL_EASYPOST_BASE, REACT_APP__URL_SMP_API, } from "@smp/utils";
export const apiTokens = {
    access_token: "",
    csrf: "",
    refresh_token: "",
    smp: "",
};
const ep = JSON.parse((typeof localStorage !== "undefined" && localStorage.getItem("ep")) || "{}");
const fallbackLanguageCode = ep.language_code || "en";
let organizationId = ep.organization_id || null;
export const getHeaders = (endpoint, headers, body) => {
    const languageCode = typeof window !== "undefined" && window.epLanguageCode
        ? window.epLanguageCode
        : fallbackLanguageCode;
    const acceptLanguage = languageCode === "en"
        ? "en-US, en;q=0.9, *;q=0.5"
        : "ru-RU, ru;q=0.9, en;q=0.8, *;q=0.5";
    const checkHeader = (header) => !!(headers === null || headers === void 0 ? void 0 : headers.some(([headerName]) => headerName.toLowerCase() === header.toLowerCase()));
    const result = [
        ...(headers || []),
        ...[["Accept-Language", `${acceptLanguage}`]],
        ...(endpoint.includes(REACT_APP__URL_SMP_API) &&
            !checkHeader("Authorization")
            ? [["Authorization", `Bearer ${apiTokens.smp}`]]
            : []),
        ...(endpoint.includes(REACT_APP__URL_EASYPOST_BASE)
            ? [["X-CSRFToken", apiTokens.csrf]]
            : []),
        ...(!(body instanceof FormData)
            ? [["Content-Type", "application/json"]]
            : []),
    ];
    if (endpoint.startsWith(REACT_APP__URL_EASYPOST_BASE) &&
        organizationId &&
        !checkHeader("X-Organization-Context")) {
        result.push(["X-Organization-Context", String(organizationId)]);
    }
    return result.reduce((acc, [key, value]) => {
        if (key.toLowerCase() === "x-organization-context" && value === "null") {
            return acc;
        }
        acc[key] = value;
        return acc;
    }, {});
};
export const encodeQueryString = (query) => {
    const keys = Object.keys(query);
    const keysFiltered = keys.filter((key) => {
        if (query[key] == null)
            return false;
        if (Array.isArray(query[key]) && !query[key].length)
            return false;
        return true;
    });
    return keysFiltered.length
        ? "?" +
            keysFiltered
                .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(query[key]))
                .join("&")
        : "";
};
let apiTokenJwtUpdatePromise;
let apiTokenJwtUpdateOrganizationId = organizationId;
export const apiTokenJwtUpdate = () => {
    if (apiTokenJwtUpdatePromise) {
        return apiTokenJwtUpdatePromise;
    }
    const url = `${REACT_APP__URL_EASYPOST_BASE}api/v1/noop`;
    apiTokenJwtUpdateOrganizationId = organizationId;
    apiTokenJwtUpdatePromise = fetch(url, {
        credentials: "include",
        headers: getHeaders(url),
    })
        .then((response) => {
        apiTokenJwtUpdatePromise = undefined;
        if (apiTokenJwtUpdateOrganizationId === organizationId) {
            apiTokens.smp = response.headers.get("X-SMP-JWT") || "";
        }
        return apiTokens.smp;
    })
        .catch((e) => {
        if (e instanceof Error) {
            throw new Error("ApiTokenJwtUpdate failed: " + e.message);
        }
        throw e;
    });
    return apiTokenJwtUpdatePromise;
};
export const setOrganizationId = (newOrganizationId) => {
    organizationId = newOrganizationId;
    apiTokenJwtUpdatePromise = undefined;
};
//# sourceMappingURL=api.static.js.map